<template>
    <div>
        <div id="fast-analysis-poster">
            <div class="row no-gutters">
                <div class="col col-2">
                    <b-icon-star-fill></b-icon-star-fill>
                </div>
                <div class="col h4">
                    <b>{{ $t("overview.poster.title") }}</b>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col col-2">
                    <b-icon-check />
                </div>
                <div class="col">
                    {{ $t("overview.poster.description.0", [formatInteger(flagsTotal)]) }}
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col col-2">
                    <b-icon-check />
                </div>
                <div class="col">
                    {{ $t("overview.poster.description.1") }}
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col col-2">
                    <b-icon-check />
                </div>
                <div class="col">
                    {{ $t("overview.poster.description.2") }}
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col col-2">
                    <b-icon-check />
                </div>
                <div class="col">
                    {{ $t("overview.poster.description.3") }}
                </div>
            </div>

            <button class="btn" @click="order(name, ico, 'lite')">{{ $t("button.order") }}</button>
        </div>

        <div id="adam-zabransky">
            <blockquote class="blockquote">
                <p class="mb-0 text-center">
                    “Kontrola ukázala na řadu problémů a rizik u evidence smluv a zakázek.
                        Pomohla nám nastartovat systémové změny k lepšímu.”
                </p>
                <footer class="blockquote-footer text-center">
                    <br />
                    Adam Zábranský
                    <br />
                    <cite>radní Hlavního města Prahy</cite>
                </footer>
            </blockquote>
        </div>
    </div>
</template>

<script>
    import formattersMixin from "@/plugins/formattersMixin.js";
    import analysisMixin from "@/plugins/analysisMixin.js";

    export default {
        props: {
            name: { required: true },
            ico: { required: true },
            flagsTotal: { required: true },
        },
        mixins: [formattersMixin, analysisMixin],
        name: "teaser-ad",
    };
</script>

<style lang="scss">
    @import "src/scss/custom";
    @import "src/scss/utils";

    #adam-zabransky {
        margin: 30px 15px 0 0;

        p {
            font-size: $small-font-size;
        }

        footer {
            font-size: $small-font-size * 0.7;

            &:before {
                content: "";
            }
        }
    }

    #fast-analysis-poster {
        color: white;
        border: solid 1px $secondary;
        background-image: linear-gradient(157deg, rgba(228, 0, 44, 0.57) -7%, $secondary);
        border-radius: 5px;
        padding: 20px 10px;
        margin: 30px 15px 0 0;

        .row {
            margin-bottom: 20px;
        }

        button {
            @include colorize-clickable(lighten($secondary, 50%));

            color: $secondary;
            font-weight: bold;
            margin: 0 auto;
            display: block;
            width: 80%;
        }
    }
</style>
